<template>
  <button
    v-if="!isActive"
    type="button"
    class="site-notice-entry"
    :class="{
      'site-notice-entry--mobile': mobile,
      'site-notice-entry--with-companion': hasCompanion,
      'site-notice-entry--action-footer': actionFooter
    }"
    aria-label="查看平台公告"
    title="平台公告"
    @click="goNotice"
  >
    <NotificationOutlined />
    <span>公告</span>
  </button>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { NotificationOutlined } from '@ant-design/icons-vue'

interface Props {
  mobile?: boolean
  hasCompanion?: boolean
  actionFooter?: boolean
}

withDefaults(defineProps<Props>(), {
  mobile: false,
  hasCompanion: false,
  actionFooter: false
})

const route = useRoute()
const router = useRouter()
const isActive = computed(() => route.path === '/notice')

const goNotice = () => {
  if (!isActive.value) {
    router.push('/notice')
  }
}
</script>

<style scoped lang="less">
.site-notice-entry {
  position: fixed;
  right: 22px;
  top: 50%;
  z-index: 1288;
  width: 52px;
  height: 52px;
  padding: 0;
  border: 1px solid rgba(251, 191, 36, 0.58);
  border-radius: 50%;
  background:
    radial-gradient(120% 150% at 0 0, rgba(253, 224, 71, 0.26), transparent 58%),
    linear-gradient(145deg, rgba(245, 158, 11, 0.96), rgba(30, 41, 59, 0.98));
  color: #fff7ed;
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1px;
  cursor: pointer;
  transform: translateY(-50%);
  box-shadow:
    0 18px 44px rgba(2, 6, 23, 0.42),
    0 0 0 1px rgba(255, 255, 255, 0.08) inset;
  transition: transform 0.18s ease, border-color 0.18s ease, box-shadow 0.18s ease;
}

.site-notice-entry--with-companion:not(.site-notice-entry--mobile) {
  top: calc(50% + 32px);
}

.site-notice-entry:hover {
  border-color: rgba(253, 224, 71, 0.92);
  box-shadow:
    0 22px 54px rgba(2, 6, 23, 0.5),
    0 0 22px rgba(251, 191, 36, 0.3);
}

.site-notice-entry:hover {
  transform: translateY(calc(-50% - 2px));
}

.site-notice-entry :deep(.anticon) {
  font-size: 19px;
  line-height: 1;
}

.site-notice-entry span {
  font-size: 10px;
  line-height: 1;
  font-weight: 900;
  letter-spacing: 0;
}

.site-notice-entry--mobile {
  top: auto;
  right: 14px;
  bottom: calc(82px + env(safe-area-inset-bottom));
  width: 48px;
  height: 48px;
  transform: none;
}

.site-notice-entry--mobile:hover {
  transform: translateY(-2px);
}

.site-notice-entry--mobile.site-notice-entry--action-footer {
  bottom: calc(116px + env(safe-area-inset-bottom));
}

@media (max-width: 380px) {
  .site-notice-entry--mobile {
    right: 10px;
    width: 44px;
    height: 44px;
  }
}
</style>
